module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.102cc73a.jpg";